"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssistChipMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ChipSpinner = require("../../components/AssistChip/ChipSpinner.styles");
var _Avatar = require("../../components/Avatar/Avatar.styles");
var _ButtonIcon = require("../../components/ButtonIcon/ButtonIcon.styles");
var _sizeMixin = require("../sizeMixin");
var _spaceMixin = require("../spaceMixin");
var _ChipMixin = require("./ChipMixin");
var loadingCSS = function loadingCSS(props) {
  var loading = props.loading;
  if (!loading) {
    return '';
  }
  return (0, _styledToken.default)({
    opacity: 'Chip.opacity.disabled',
    spinnerSize: 'Chip.spinnerSize'
  }, function (_ref) {
    var spinnerSize = _ref.spinnerSize,
      opacity = _ref.opacity;
    return (0, _styledComponents.css)(["pointer-events:none;opacity:", ";", ",", "{display:none;}", "{line-height:", "px;margin-right:", ";}"], opacity, _Avatar.StyledAvatar, _ButtonIcon.StyledButtonIcon, _ChipSpinner.StyledChipSpinner, spinnerSize, (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};

/** @class AssistChipMixin */
/** @method */
var AssistChipMixin = function AssistChipMixin(props) {
  return (0, _styledToken.default)({
    borderWidth: "Chip.borderWidth",
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref2) {
    var borderWidth = _ref2.borderWidth,
      fontType = _ref2.fontType,
      height = _ref2.height;
    return (0, _styledComponents.css)(["", " justify-content:left;", " ", ""], (0, _ChipMixin.ChipMixin)(props), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), loadingCSS(props));
  })(props);
};
exports.AssistChipMixin = AssistChipMixin;